import { FC } from 'react';

import {
  isFetchingMore,
  isLoading,
  isSettingVariables,
} from 'common/graphql/networkStatus';
import useDebounce from 'common/hooks/useDebounce';
import ErrorCard from 'components/ErrorCard';
import ModalProvider from 'components/ModalProvider';
import { logEvent } from 'features/Analytics/analytics';
import { ClientModalsProvider } from 'features/Work/hooks/useClientModals';
import * as Layout from 'layouts/ContentLayout';

import Filters from '../../../../components/Filters';
import { ClientListBody } from '../../../../components/WorkListBody';
import { useFilters } from '../../../hooks/useFilters';
import { ClientModalProvider } from '../../components/Modals';
import ListHeader from './components/ListHeader';
import { useGetClients } from './hooks/queries/useGetClients';
import locales from './locales';

const List: FC = () => {
  const { filters } = useFilters();
  const searchInput = useDebounce(filters?.q ?? '');

  const { clients, error, fetchMore, networkStatus, pageInfo, refetch } =
    useGetClients(searchInput ? { searchInput } : undefined);

  if (error) {
    return <ErrorCard retry={refetch} />;
  }

  const onFetchMore = () => {
    logEvent({
      name: 'Clients More Loaded',
      usePrefix: false,
    });
    fetchMore();
  };

  return (
    <ClientModalsProvider>
      <ModalProvider>
        <ClientModalProvider>
          <Layout.Root>
            <Layout.Body size="md">
              <ListHeader />

              <Filters placeholder={locales.searchbar} />

              <ClientListBody
                clients={clients}
                hasNextPage={pageInfo?.hasNextPage ?? false}
                isFetchingMore={isFetchingMore(networkStatus)}
                loading={
                  isLoading(networkStatus) || isSettingVariables(networkStatus)
                }
                onFetchMore={onFetchMore}
              />
            </Layout.Body>
          </Layout.Root>
        </ClientModalProvider>
      </ModalProvider>
    </ClientModalsProvider>
  );
};

export default List;
